import styled from 'styled-components';
import {
  blackSphera,
  grayLightSphera,
  whiteSphera,
  greenSp
} from 'src/utilities/UIStyles/variables/Colors';

export const SignupContainer = styled.section`
  display: flex;
  margin-bottom: 5%;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const SignupInfo = styled.div`
  width: 50%;
  padding: 10% 0 0 5%;

  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    line-height: 50px;
    width: 82%;
    margin-bottom: 2.5%;

    > span {
      color: ${greenSp};
    }
  }

  > p {
    color: ${blackSphera};
    font-size: 1.6vw;
    width: 82%;

    > span {
      font-weight: bold;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    padding: 15% 0 5% 5%;

    > h2 {
      line-height: 40px;

      > span {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    padding: 25% 0 5% 5%;

    > h2 {
      font-size: 7vw;
      line-height: 40px;
      width: 95%;
      margin-bottom: 2.5%;

      > span {
      }
    }

    > p {
      font-size: 6vw;
      width: 95%;

      > span {
      }
    }
  }
`;

export const SignupForm = styled.div`
  width: 65%;
  padding: 10% 0 5% 5%;
  background-image: url('https://finsphera-webapp-resources.s3.amazonaws.com/img_app_signup.png');
  background-size: cover;

  > form {
    display: flex;
    flex-direction: column;
    width: 55%;
    margin: auto;
    padding: 5%;
    border-radius: 5px;
    background-color: ${whiteSphera};

    > h3 {
      color: ${blackSphera};
      font-size: 1.6vw;
      font-weight: bold;
      text-align: center;
      margin-bottom: 5%;
    }

    > input:nth-child(2) {
      font-size: 1rem;
      padding-bottom: 1%;
      border: none;
      border-bottom: 1px solid ${grayLightSphera};
      margin-bottom: 2.5%;

      &::placeholder {
        color: ${grayLightSphera};
      }
    }

    > div:nth-child(3),
    > div:nth-child(4) {
      display: flex;
      margin-top: 1%;
      margin-bottom: 2.5%;
      padding-bottom: 1%;
      border-bottom: 1px solid ${grayLightSphera};

      > input {
        font-size: 1rem;
        width: 90%;
        padding-bottom: 1%;
        border: none;

        &::placeholder {
          color: ${grayLightSphera};
        }
      }

      > figure:nth-child(2) {
        width: 20px;
        height: 19px;
        margin-right: 2.5%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      > figure:nth-child(3) {
        width: 25px;
        height: 20px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    > h4 {
      font-size: 0.8rem;
      margin-bottom: 3%;
      color: ${blackSphera};

      > span {
        color: ${greenSp};
        font-weight: bold;
        cursor: pointer;
      }
    }

    > div:nth-child(6) {
      display: flex;
      width: 100%;
      align-items: baseline;
      margin: 5% 0;
      > input {
        cursor: pointer;
        background-color: orange;
        padding-top: 5%;
      }
      > p {
        font-size: 1.1vw;
        color: ${blackSphera};
        margin-left: 2%;
        > a {
          color: ${greenSp};
          font-weight: bold;
          text-decoration: none;
        }
      }
    }

    > input[type='submit'] {
      color: ${whiteSphera};
      font-weight: bold;
      font-size: 1.2vw;
      text-decoration: none;
      text-align: center;
      line-height: 50px;
      width: 60%;
      height: 50px;
      margin: auto;
      border: none;
      border-radius: 5px;
      background-color: ${blackSphera};
      cursor: pointer;
    }

    > p:nth-child(8) {
      font-size: 1.3vw;
      color: ${blackSphera};
      text-align: center;
      margin-top: 5%;
      margin-bottom: 2%;
    }

    > a:nth-child(9) {
      font-size: 1.2vw;
      font-weight: bold;
      color: ${greenSp};
      text-decoration: none;
      text-align: center;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    width: 100%;
    > form {
      width: 95%;
      margin: 5% 0;
      > h3 {
        font-size: 5vw;
      }
      > input:nth-child(2) {
        font-size: 1rem;
        &::placeholder {
        }
      }
      > div:nth-child(3),
      > div:nth-child(4) {
        margin-bottom: 5%;

        > input {
          font-size: 4vw;
          width: 90%;

          &::placeholder {
          }
        }
      }
      > div:nth-child(6) {
        > input {
          margin-top: 2%;
          margin-right: 2.5%;
        }
        > p {
          font-size: 4.5vw;
        }
      }
      > input[type='submit'] {
        font-size: 4.5vw;
        width: 95%;
      }
      > p:nth-child(8) {
        font-size: 4vw;
      }
      > a:nth-child(9) {
        font-size: 4vw;
      }
    }
  }
`;
